var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classNames } from '../../utils/styles';
import { SectionContainer, SectionTitle } from '../styles';
import { Container, ImageSection, Image, TextContent, ImageSectionWrapper, } from './styles';
export var About = function (_a) {
    var section = _a.section;
    var featuredText = section.featuredText, completeDescription = section.completeDescription, pageTitle = section.pageTitle, image = section.image;
    var showContent = featuredText || completeDescription || pageTitle;
    return (_jsxs(Container, { children: [image && (_jsx(ImageSectionWrapper, __assign({ className: classNames({
                    pb: !showContent,
                }) }, { children: _jsx(ImageSection, { children: _jsx(Image, { image: image }, void 0) }, void 0) }), void 0)), showContent && (_jsxs(SectionContainer, { children: [_jsx(SectionTitle, __assign({ className: "nmb" }, { children: pageTitle }), void 0), _jsxs(TextContent, { children: [featuredText && (_jsx("div", { children: _jsx("h2", __assign({ className: classNames({
                                        mt: !!pageTitle,
                                    }) }, { children: featuredText }), void 0) }, void 0)), completeDescription && (_jsx("div", { children: _jsx("p", __assign({ className: classNames({
                                        mt: !!pageTitle || !!featuredText,
                                    }) }, { children: completeDescription }), void 0) }, void 0))] }, void 0)] }, void 0))] }, void 0));
};
